import { Div } from "@tblabs/truffle";


export class Svg extends Div
{
    constructor(asText: string)
    {
        super();
        this.DisplayInlineBlock();
        this.Html(asText);
    }
}
